import { type TypedDocumentNode, gql } from '@apollo/client';
import { useState } from 'react';

import { useSnackNotificationContext } from '@sorare/core/src/contexts/snackNotification';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';
import { useSubscription } from '@sorare/core/src/hooks/useSubscription';

import type {
  CurrentUserTaskWasUpdatedSubscription,
  CurrentUserTaskWasUpdatedSubscriptionVariables,
} from './__generated__/useCurrentUserTaskWasUpdatedToast.graphql';

const CURRENT_USER_TASK_WAS_UPDATED_SUBSCRIPTION = gql`
  subscription CurrentUserTaskWasUpdatedSubscription {
    currentUserTaskWasUpdated {
      previousProgress
      task {
        id
        title
      }
    }
  }
` as TypedDocumentNode<
  CurrentUserTaskWasUpdatedSubscription,
  CurrentUserTaskWasUpdatedSubscriptionVariables
>;

type CurrentUserTaskWasUpdatedPayload = NonNullable<
  CurrentUserTaskWasUpdatedSubscription['currentUserTaskWasUpdated']
>;

export const useCurrentUserTaskWasUpdatedToast = () => {
  const { showNotification } = useSnackNotificationContext();
  const [accumulatedData, setAccumulatedData] = useState<
    CurrentUserTaskWasUpdatedPayload[]
  >([]);
  const {
    flags: { useMissionToasts = false },
  } = useFeatureFlags();

  //todo Damien in follow up MR check if there is a dialog currently displayed
  const isDialogVisible = false;

  if (accumulatedData.length > 0 && !isDialogVisible && useMissionToasts) {
    accumulatedData.forEach(({ task }) => {
      //todo Damien in follow up MR use a custom notification for missions
      showNotification('watchlistUpdated', {
        title: task.title,
      });
    });
    setAccumulatedData([]);
  }

  useSubscription(CURRENT_USER_TASK_WAS_UPDATED_SUBSCRIPTION, {
    skip: !useMissionToasts,
    onData({ data }) {
      const { currentUserTaskWasUpdated } = data.data || {};
      if (currentUserTaskWasUpdated) {
        setAccumulatedData(prev => [...prev, currentUserTaskWasUpdated]);
      }
    },
  });
};
